<template>
  <!--Highlights Section-->
  <section class="highlights-section wow fadeInUp animated">
    <div class="auto-container">
      <div class="sec-title with-separator centered">
        <h2>News</h2>
        <!-- <div class="separator">
          <span class="cir c-1"></span><span class="cir c-2"></span><span class="cir c-3"></span>
        </div> -->
        <div class="lower-text">We can accomplish more than we ever could alone</div>
      </div>
      <div class="carousel-outer">
        <div class="hi-carousel owl-theme owl-carousel">
          <!--Hi Block-->
          <div class="hi-block" v-for="(item, index) in dataList" :key="item.id">
            <div class="inner-box" @click="link_to(item.id)">
              <div class="upper-info">
                <div class="count">02</div>
                <h3>
                  {{ item.title }}
                </h3>
              </div>
              <div class="image-box">
                <figure class="image">
                  <div><img :src="item.image" alt="" /></div>
                </figure>
                <div class="image-cap clearfix">
                  <h2>
                    <div>
                      <span class="num">{{ index + 1 }}</span
                      >{{ item.title }}
                    </div>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <!--Hi Block-->
          <!-- <div class="hi-block">
            <div class="inner-box">
              <div class="upper-info">
                <div class="count">02</div>
                <h3>
                  <a href="event-details.html">The tower of <br />london</a>
                </h3>
              </div>
              <div class="image-box">
                <figure class="image">
                  <a href="event-details.html"><img src="/images/banner/2.jpg" alt="" /></a>
                </figure>
                <div class="image-cap clearfix">
                  <h2>
                    <a href="event-details.html"><span class="num">03</span> The tower of london</a>
                  </h2>
                </div>
              </div>
            </div>
          </div> -->
          <!--Hi Block-->
          <!-- <div class="hi-block">
            <div class="inner-box">
              <div class="upper-info">
                <div class="count">01</div>
                <h3>
                  <a href="event-details.html">Buckingham <br />palace</a>
                </h3>
              </div>
              <div class="image-box">
                <figure class="image">
                  <a href="event-details.html"><img src="/images/banner/3.webp" alt="" /></a>
                </figure>
                <div class="image-cap clearfix">
                  <h2>
                    <a href="event-details.html"><span class="num">01</span>Buckingham palace</a>
                  </h2>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api/index.js'
export default {
  data() {
    return {
      URLTYPE: this.$store.screen.URLTYPE,
      loading: false,
      dataList: [],
    }
  },
  mounted() {
    // this.refreshList()
  },
  methods: {
    link_to(id) {
      this.$router.push({ path: '/newsdetails/' + id })
    },
    refreshList(data) {
      this.loading = true
      if (data) {
        this.dataList = data
        this.$nextTick(() => {
          this.swiperFun()
        })
      } else {
        api
          .webList({
            pageNo: 1,
            pageSize: 5,
            isPublished: '1', //是发布的
            columnName: 'News', //是招标列表
            // type: '1', //代表正在进行招标的数据
          })
          .then((res) => {
            this.dataList = res.page.list
            this.$nextTick(() => {
              this.swiperFun()
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    swiperFun() {
      if ($('.hi-carousel').length) {
        $('.hi-carousel').owlCarousel({
          center: true,
          loop: true,
          margin: 50,
          autoplay: true,
          autoPlay: 5000,
          dots: false,
          nav: true,
          navText: [
            '<span class="icon flaticon-left-1"></span>',
            '<span class="icon flaticon-right-1"></span>',
          ],
          responsive: {
            0: {
              items: 1,
            },
            600: {
              items: 1,
            },
            768: {
              items: 1,
            },
            1024: {
              items: 1,
            },
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hi-block .image,
.hi-block .image img {
  width: 720px;
  height: 460px;
}
.highlights-section {
  padding: 0 0 80px;
  margin: 0;
}
.sec-title .lower-text {
  padding: 0;
}
.hi-block .upper-info h3 {
  width: min-content;
}
</style>
